import React, {useRef, useState} from "react";
import {
    FlexColumn,
    BoxIsolatedContent,
    FlexColumnCentered,
    FlexColumnWidth100,
    FlexRow,
    RegisterAddAvatar,
    RegisterCutPhotoExit
} from "../../components/ui/Content";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {RegisterInputContainer} from "../../components/ui/InputSearch";
import {Body1, Title} from "../../components/Font";
import {AddAvatarIcon, Union} from "../../icon/Icon";
import {useTheme} from "styled-components";
import {ButtonDefault, ButtonPrimary} from "../../components/ui/Button";
import ReactCrop, {centerCrop, Crop, makeAspectCrop} from "react-image-crop";
import {PostAvatar, setAddAvatar} from "./AccountInfo/api/slice";
import {AvatarModalBody} from "../../components/ui/Modal";


function centerAspectCrop(
    mediaWidth: number,
    mediaHeight: number,
    aspect: number,
) {
    return centerCrop(
        makeAspectCrop(
            {
                unit: 'px',
                width: 400
            },
            aspect,
            mediaWidth,
            mediaHeight,
        ),
        mediaWidth,
        mediaHeight,
    )
}

let refInput: HTMLInputElement;

export const AddAvatar = () => {
    const {addAvatar} = useAppSelector(state => state.account)
    const [isCut, setIsCut] = useState(false)
    const initCrop: Crop = {
        x: 0,
        y: 0,
        width: 400,
        height: 400,
        unit: "px",
    }
    const dispatch = useAppDispatch()
    const [srcImg, setSrcImg] = useState('');
    const [image, setImage] = useState<HTMLImageElement | null>(null);
    const [crop, setCrop] = useState(initCrop);
    const inputRef = useRef(refInput);
    const imgRef = useRef<HTMLImageElement>(null)
    const aspect = 1
    const Theme = useTheme()

    const handleImage = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files)
            setSrcImg(URL.createObjectURL(event.target.files[0]));
    };

    const getCroppedImg = async () => {
        if (image) {
            const canvas = document.createElement("canvas");
            const scaleX = image.naturalWidth / image.width;
            const scaleY = image.naturalHeight / image.height;
            canvas.width = crop.width;
            canvas.height = crop.height;
            const ctx = canvas.getContext("2d");
            if (ctx) {
                ctx.drawImage(
                    image,
                    crop.x * scaleX,
                    crop.y * scaleY,
                    crop.width * scaleX,
                    crop.height * scaleY,
                    0,
                    0,
                    crop.width,
                    crop.height
                );
            }
            canvas.toBlob(function (blob) {
                const formData = new FormData();
                if (blob !== null) {
                    formData.append('avatar', blob);
                    dispatch(PostAvatar(formData))
                }
            });
        }
    };

    function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
        setImage(e.currentTarget)
        if (aspect) {
            const {width, height} = e.currentTarget
            setCrop(centerAspectCrop(width, height, aspect))
        }
    }


    return <div className={'background body1'}>
        <FlexColumnCentered
            className={'box-isolated box-isolated-avatar'}>
            <BoxIsolatedContent>
            {srcImg &&
                <FlexColumnWidth100 className={isCut ? 'visible' : 'invisible'}>
                    <FlexRow>
                        <Title>Фотография профиля</Title>
                        <RegisterCutPhotoExit onClick={() => {
                            setSrcImg('')
                            setIsCut(false)
                        }}>
                            <Union/>
                        </RegisterCutPhotoExit>
                    </FlexRow>
                    <RegisterInputContainer style={{marginLeft: '-48px'}}>
                        <FlexColumn>
                            <AvatarModalBody style={{paddingTop: '24px', marginLeft: '48px'}}>
                                <ReactCrop
                                    style={{maxHeight: '320px'}}
                                    crop={crop}
                                    onChange={(crop) => setCrop(crop)}
                                    aspect={aspect}
                                    circularCrop={true}
                                >
                                    <img
                                        style={{maxHeight: '320px'}}
                                        ref={imgRef}
                                        alt="Crop me"
                                        src={srcImg}
                                        onLoad={onImageLoad}
                                    />
                                </ReactCrop>
                            </AvatarModalBody>
                            <ButtonPrimary style={{marginLeft: '24px'}} onClick={() => {
                                getCroppedImg()
                            }}>
                                Сохранить
                            </ButtonPrimary>
                            <ButtonDefault
                                onClick={() => {
                                    setSrcImg('')
                                    setIsCut(false)
                                }}
                                style={{marginTop: '0px', marginLeft: '24px'}}>
                                Отмена
                            </ButtonDefault>
                        </FlexColumn>
                    </RegisterInputContainer>
                </FlexColumnWidth100>
                ||
                <>
                    <input type="file"
                           ref={inputRef}
                           onChange={handleImage}
                           accept="image/jpeg,image/png"
                           hidden
                    />
                    <FlexColumnWidth100 className={addAvatar ? 'visible' : 'invisible'}>
                        <Title>Ваш аккаунт готов!</Title>
                        <RegisterInputContainer>
                            <RegisterAddAvatar onClick={() => {
                                inputRef.current.click()
                                setIsCut(true)
                            }}>
                                <AddAvatarIcon/>
                            </RegisterAddAvatar>
                            <Body1 color={Theme.color.secondary}>Выберите фото для вашего профиля</Body1>
                            <ButtonPrimary onClick={() => {
                                inputRef.current.click()
                                setIsCut(true)
                            }}>
                                Выбрать фото
                            </ButtonPrimary>
                            <ButtonDefault
                                onClick={() => dispatch(setAddAvatar(false))}
                                style={{marginTop: '0px'}}
                            >
                                Пропустить
                            </ButtonDefault>
                        </RegisterInputContainer>
                    </FlexColumnWidth100>
                </>
                }
            </BoxIsolatedContent>
        </FlexColumnCentered>
    </div>
}